import getRuleError from "./getRuleError";
import getRuleValue from "./getRuleValue";
import {translate} from "../../../../i18n";

export default function getRequiredError($rules, $options, $allValues) {
    const {required} = $rules;

    if (required === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(required, $allValues);

    if (ruleValue !== true) {
        return null;
    }

    return getRuleError(required, $allValues, translate('Required'));
}
